// GENERATED FILE - DO NOT MODIFY
import { ContactLookupModel } from "api/models/company/contact/contact-lookup-model";
import { ContactModel } from "api/models/company/contact/contact-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class CustomerContactProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetClientContacts(clientId: string | null, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactModel[] | null> {
        const uri = this.buildUri(
            "/clients/{clientId}/contacts",
            { clientId: (clientId === null || clientId === undefined) ? undefined : clientId },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactModel[] | null = await this.get<ContactModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactModel");
        return data;
    }

    public async GetClientContactsLookup(clientId: string | null, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ContactLookupModel[] | null> {
        const uri = this.buildUri(
            "/clients/{clientId}/contacts/lookup",
            { clientId: (clientId === null || clientId === undefined) ? undefined : clientId },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ContactLookupModel[] | null = await this.get<ContactLookupModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Contact.ContactLookupModel");
        return data;
    }
}
